import { set } from 'cerebral/operators'

import checkIsAdmin from '../actions/checkIsAdmin.js'
import getUsers from '../actions/getUsers.js'
import isShouldGetUsers from '../actions/isShouldGetUsers.js'
import setUsers from '../actions/setUsers.js'
import checkLoggedIn from '../actions/checkLoggedIn.js'
import redirect from 'cerebral-module-router/redirect'

export default [
  checkIsAdmin,
  {
    true: [
      set('state:client.forms.showSnackbar', false),
      isShouldGetUsers,
      {
        true: [
          getUsers,
          {
            success: [
              setUsers,
              set('state:users.currentView', 'approved'),
              set('state:client.currentPage', 'users')
            ],
            error: []
          }
        ],
        false: [
          set('state:client.currentPage', 'users'),
          set('state:users.currentView', 'approved')
        ]
      }
    ],
    false: [
      checkLoggedIn,
      {
        success: [redirect('/welcome')],
        error: [redirect('/login')]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/getUsers.js